import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import HomeMain from './HomeMain';
import Footer from '../../components/Layout/Footer';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/logo-1.png';
import BackToTop from '../../components/elements/BackToTop';


const Home = () => {
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("scroll", handleScroll);
        return () => document.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <title>U Brand It - Professional Promotional Products & Branded Merchandise</title>
                <meta name="description" content="Custom promotional products and branded merchandise for businesses, events, and organizations. On Time • On Point • On Budget. Call 800-721-5822 for a free quote." />
                <meta name="keywords" content="promotional products, branded merchandise, custom apparel, corporate gifts, event materials, U Brand It, promotional items, business branding" />
                <link rel="canonical" href="https://ubranditpa.com/" />
                
                {/* Open Graph */}
                <meta property="og:title" content="U Brand It - Professional Promotional Products & Branded Merchandise" />
                <meta property="og:description" content="Custom promotional products and branded merchandise for businesses, events, and organizations. On Time • On Point • On Budget." />
                <meta property="og:url" content="https://ubranditpa.com/" />
                <meta property="og:type" content="website" />
                
                {/* Twitter */}
                <meta name="twitter:title" content="U Brand It - Professional Promotional Products & Branded Merchandise" />
                <meta name="twitter:description" content="Custom promotional products and branded merchandise for businesses, events, and organizations. On Time • On Point • On Budget." />
            </Helmet>
            <Header
                navImg={navImg1}
                parentMenu='home'
                activeMenu="/"
            />
             <HomeMain />
            <BackToTop scroll={isVisible} />
            <Footer />
        </React.Fragment>
    );
}

export default Home;
